import Medusa from '@adoratorio/medusa';
import { initials, animations } from '@/scripts/fx';

const medusa = {
  ref: null,

  prevNodes: [],

  init() {
    medusa.ref = new Medusa({
      targets: [{
        id: 'scrollAnimations',
        container: document.body,
        nodes: [],
        threshold: 0,
        offsets: window.innerWidth < 960 ? '0px 0px -80px 0px' : '0px 0px -180px 0px',
        mode: Medusa.MODE.ONCE,
        callback: medusa.callbackAnimation,
        emitGlobal: true,
        autoremove: false,
      },
      {
        id: 'checkInViewport',
        container: document.body.querySelector('.app'),
        nodes: [],
        threshold: 0,
        offsets: '100px 0px 100px 0px',
        mode: Medusa.MODE.DEFAULT,
        callback: medusa.callbackInViewport,
        emitGlobal: true,
        autoremove: false,
      }],
      debug: false,
    });
  },

  callbackAnimation(event) {
    const animation = event.target.dataset.animation !== undefined
      ? event.target.dataset.animation : event.target.dataset.lazyanimation;
    animations.get(animation)(event.target);
  },

  callbackInViewport(event) {
    if (event.target.hasAttribute('data-inviewport') && !event.isIntersecting) {
      event.target.removeAttribute('data-inviewport');
    } else if (!event.target.hasAttribute('data-inviewport') && event.isIntersecting) {
      event.target.setAttribute('data-inviewport', '');
    }
  },

  recalculateTargets(element) {
    const nodes = Array.from(element.querySelectorAll('[data-animation]'));
    nodes.forEach(node => initials.get(node.dataset.animation)(node));
    medusa.ref.pushToTarget('scrollAnimations', nodes);
    medusa.prevNodes = nodes;
  },

  removePrevTargets() {
    medusa.ref.pullFromTarget('scrollAnimations', medusa.prevNodes);
  },
};

export default medusa;
